import { render, staticRenderFns } from "./LapidusRegister.vue?vue&type=template&id=e166f848&"
import script from "./LapidusRegister.vue?vue&type=script&lang=js&"
export * from "./LapidusRegister.vue?vue&type=script&lang=js&"
import style0 from "./LapidusRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports